import AssignmentIcon from '@mui/icons-material/Assignment';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { Box, Link, Stack } from '@mui/material';
import { ContentCard, MobileBody, MobileTitle } from 'lib/mobileDesignSystem';
import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RootState } from 'services/redux/store';

const Home: React.FC = () => {
  const user = useSelector((state: RootState) => state.auth.user);
  const navigate = useNavigate();

  return (
    <Stack
      sx={{
        flex: 1,
        minHeight: '100%',
        alignItems: 'center',
        py: 3,
        gap: 8,
      }}
    >
      <Box sx={{ textAlign: 'center' }}>
        <MobileTitle gutterBottom>¡Hola {user?.name}! 👋🏼</MobileTitle>
        <MobileBody color="text.secondary">Bienvenido a Pruff</MobileBody>
      </Box>
      <ContentCard
        header={{
          icon: <AssignmentIcon sx={{ fontSize: 20 }} />,
          title: 'Factoring',
          description: 'Gestiona tus solicitudes.',
          clickable: true,
          onClick: () => navigate(`/finance`),
        }}
        sx={{ width: '100%', maxWidth: 400 }}
      >
        <Box
          sx={{
            py: 3,
            display: 'flex',
            flex: 1,
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Link
            component="button"
            variant="body2"
            onClick={() => navigate('/finance')}
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 0.5,
              textAlign: 'center',
              textDecoration: 'underline',
            }}
          >
            Ir a módulo
            <NavigateNextIcon sx={{ fontSize: 20 }} />
          </Link>
        </Box>
      </ContentCard>
    </Stack>
  );
};

export default Home;
